// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__94bcW","checkIcon":"styles_checkIcon__7zzB_","checked":"styles_checked__gi9fh"};